/**
 *
 * IBM Confidential
 *
 * (C) Copyright IBM Corp. 2021, 2025
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U. S. Copyright Office
 *
 * US Government Users Restricted Rights - Use, duplication or
 * disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 **/

import urlJoin from 'proper-url-join';

import { isCpd } from '@ibm-watson/shared/modules/ia/util/config';
import { generateDocsUrl } from '../../../ia/util/docs';

export const links = {
  awsAccountLink: 'https://console.aws.amazon.com/connect/',
  awsFindArn:
    'https://docs.aws.amazon.com/connect/latest/adminguide/find-instance-arn.html',
  awsLearnMore:
    'https://cloud.ibm.com/docs/watson-assistant?topic=watson-assistant-deploy-phone-amazon-connect#deploy-phone-amazon-connect-claim-phone-number',
  awsSteps:
    'https://docs.aws.amazon.com/connect/latest/adminguide/claim-phone-number.html',
  genesysAudioConnectorDocs: generateDocsUrl(
    '/watson-assistant?topic=watson-assistant-deploy-genesys-audioconnector'
  ),
  phoneLearnMoreNewIA: generateDocsUrl(
    '/watson-assistant?topic=watson-assistant-deploy-phone'
  ),
  phoneLearnMoreClassicIA: generateDocsUrl(
    '/assistant?topic=assistant-deploy-phone'
  ),
  learnMorePairSmsLink: generateDocsUrl('/?topic=assistant-deploy-sms'),
  learnMorePairSmsNewIA: generateDocsUrl(
    '/watson-assistant?topic=watson-assistant-deploy-sms'
  ),
  TWILIO_SIP_TRUNKING: 'https://www.twilio.com/sip-trunking',
  learnMorePhoneReqLink: generateDocsUrl(
    '/?topic=assistant-deploy-phone#deploy-phone-request-setup'
  ),
  learnMorePhoneIntegLink: generateDocsUrl(
    '/?topic=assistant-deploy-phone#deploy-phone-sip-providers'
  ),
  sipTrunkProvidersNewIA: generateDocsUrl(
    '/watson-assistant?topic=watson-assistant-deploy-phone-config#deploy-phone-config-sip-providers'
  ),
  learnMoreOtherSipLink: generateDocsUrl(
    '/?topic=assistant-deploy-phone#deploy-phone-request-setup'
  ),
  learnMoreAdvancedOptionsLink: generateDocsUrl(
    '/?topic=assistant-deploy-phone#deploy-phone-advanced'
  ),
  learnMoreAdvancedOptionsNewIA: generateDocsUrl(
    '/watson-assistant?topic=watson-assistant-deploy-phone-config#deploy-phone-config-sip-trunk'
  ),
  learnMoreAdvancedOptionsModalLink: generateDocsUrl(
    '/watson-assistant?topic=watson-assistant-deploy-phone-config#deploy-phone-config-failure'
  ),
  learnMoreNiceCXoneLink:
    'https://cloud.ibm.com/docs/watson-assistant?topic=watson-assistant-deploy-phone-nicecxone',
  learnMoreAmazonConnectLink:
    'https://cloud.ibm.com/docs/watson-assistant?topic=watson-assistant-deploy-phone-amazon-connect',
  learnMoreSttModels: generateDocsUrl(
    '/speech-to-text?topic=speech-to-text-models'
  ),
  learnMoreDeprecatedSttModels: urlJoin(
    'https://cloud.ibm.com',
    'docs/speech-to-text?topic=speech-to-text-release-notes#speech-to-text-15february2023',
    { queryOptions: { encode: false } }
  ),
  learnMoreTtsVoices: generateDocsUrl(
    '/text-to-speech?topic=text-to-speech-voices'
  ),
  customDeployment: generateDocsUrl(
    '/account/reg/us-en/signup?formid=MAIL-watson'
  ),
  genesysServiceDesk: generateDocsUrl(
    '/assistant?topic=assistant-deploy-phone-genesys'
  ),
  genesysServiceDeskNewIA: generateDocsUrl(
    '/watson-assistant?topic=watson-assistant-deploy-phone-genesys'
  ),
  intelepeerServiceDesk: urlJoin(
    'https://info.intelepeer.com',
    '/ip-ibm-2021-76899.html',
    { queryOptions: { encode: false } }
  ),
  twilioServiceDesk: generateDocsUrl('/?topic=assistant-deploy-phone-flex'),
  twilioServiceDeskNewIA: generateDocsUrl(
    '/watson-assistant?topic=watson-assistant-deploy-phone-flex'
  ),
  byoSipTrunk: generateDocsUrl(
    '/assistant?topic=assistant-deploy-phone#deploy-phone-request-setup'
  ),
  byoServiceDesk: generateDocsUrl(
    '/assistant?topic=assistant-deploy-phone#deploy-phone-transfer-service'
  ),
  byoServiceDeskNewIA: generateDocsUrl(
    '/watson-assistant?topic=watson-assistant-deploy-phone-config#deploy-phone-config-byost'
  ),
  niceInContactLogin:
    'https://login.incontact.com/inContact/Login.aspx?ReturnUrl=%2f',
  elevenLabsVoiceSettings:
    'https://elevenlabs.io/docs/api-reference/voices/get-settings#response'
};

// We must use complete URL.  The UI server only
// 'fixes' Assistant doc URLs.
export function getSttLearnLink() {
  return isCpd
    ? generateDocsUrl('/speech-to-text')
    : urlJoin('http://cloud.ibm.com', 'docs/speech-to-text', {
        queryOptions: { encode: false }
      });
}

// We must use complete URL.  The UI server only
// 'fixes' Assistant doc URLs.
export function getTtsLearnLink() {
  return isCpd
    ? generateDocsUrl('/text-to-speech')
    : urlJoin('http://cloud.ibm.com', 'docs/text-to-speech', {
        queryOptions: { encode: false }
      });
}
